// extracted by mini-css-extract-plugin
export default {"container":"FileItem_container__Y+ZSq","name":"FileItem_name__XkX4H","icon":"FileItem_icon__YfXBo","label":"FileItem_label__S9sdP"};